/*
 * @Author: your name
 * @Date: 2022-10-24 16:27:20
 * @LastEditTime: 2022-12-08 14:53:18
 * @LastEditors: zhang lin
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/pages/EnvManage/SysNoSupOS/messages.js
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  groupServer: '所在服务器: { ip } (运维平台服务器)',
  useable: '可用',
  used: '已用',
  total: '共',
  packPosition: '安装包放置位置',
  noPackage: '无安装包',
  packageList: '可安装文件列表',
  fromDatabase: '从资源库获取',
  refersh: '刷新列表',
  initPage: '未找到安装包',
  supOSPackage: 'supOS安装包',
  visualInstallation: '可视化安装',
  need: '需要完成',
  hostDeployment: '主机部署',
  startInstallation: '才能开始安装',
  serverTime: '环境时间',
  success: '设置成功',
});
